import { AfterViewInit, Component, computed, inject, input, OnDestroy, output } from '@angular/core';
import { BaseComponent } from '../../component-base';
import { News } from '../../../core/services/models/news';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';

export type NewsPreview = {
  image?: Blob | string | number,
  text?: string
}

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss'
})
export class NewsComponent extends BaseComponent implements AfterViewInit, OnDestroy {

  private NEWS_KEY = "last_seen_news_id";
  public news: (News & { 
    safeUrl?: SafeUrl
  })[] = [];
  public lastId = parseInt(localStorage.getItem(this.NEWS_KEY) || '0');
  public previewObjectUrl?: string;
  public safeUrl?: SafeUrl;
  private sanitizer = inject(DomSanitizer)

  /**
   * As admin you may see the preview.
   */
  public preview = input<NewsPreview>();
  public closed = output();

  public currentContentKey = computed(() => {
    return `text_${this.currentLang()}` as keyof News;
  });

  public currentHTML = computed(()=>{
    return this.sanitizer.bypassSecurityTrustHtml(<string>this.news[0][`text_${this.currentLang()}` as keyof News]);
  })

  ngAfterViewInit(): void {
    if (!this.preview()) {
      this.restApiService.getNews().subscribe({
        next: (resp) => {
          this.news = resp.filter(n => n.id > this.lastId).reverse();
        }
      });
    }
    else {
      var img: { safeUrl?: SafeUrl, image1_id?: number } = {};

      if (this.preview()?.image) {
        if (this.preview()?.image instanceof Blob) {
          this.previewObjectUrl = URL.createObjectURL(<Blob>this.preview()!.image!);
          this.safeUrl = this.sanitizer.bypassSecurityTrustUrl(this.previewObjectUrl);
          img = { safeUrl: this.safeUrl };
        }
        else {
          img = { image1_id: <number>this.preview()?.image }
        }

      }

      this.news = [Object.assign({
        id: 0,
        text_hu: this.preview()?.text,
        text_en: this.preview()?.text,
        text_de: this.preview()?.text,
        text_it: this.preview()?.text,
      }, img)];
    }

  }

  override ngOnDestroy(): void {
    if (this.previewObjectUrl) {
      URL.revokeObjectURL(this.previewObjectUrl);
    }
  }

  public close() {
    if (!this.preview() && this.lastId < this.news[0].id) {
      this.lastId = this.news[0].id;
      localStorage.setItem(this.NEWS_KEY, this.lastId + '');
    }
    this.news.splice(0, 1);
    this.closed.emit();
  }
}
